import { useNavigate } from 'react-router-dom';
import { Card } from '@/shared/ui/primitives';
import { useTranslation } from 'react-i18next';
import PageHeader from '@/shared/components/PageHeader';
import CountryForm from '../components/CountryForm';
import { useCreateCountry } from '../hooks/useCountryMutations';
import type { CountryFormData } from '@/shared/types';

export default function CountryCreatePage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const mutation = useCreateCountry();

  const handleSubmit = (data: CountryFormData) => {
    mutation.mutate(data, { onSuccess: () => navigate('/countries') });
  };

  return (
    <div>
      <PageHeader back title={t('countries.addNew')} />
      <Card style={{ marginTop: 16 }}>
        <CountryForm onSubmit={handleSubmit} isLoading={mutation.isPending} />
      </Card>
    </div>
  );
}
